import { gql } from '@apollo/client';

export const LOG_OUT = gql`
  query logout {
    logout {
      id
    }
  }
`;

export const LOG_IN = gql`
  query Login($email: String!, $password: String!, $rememberMe: Boolean) {
    login(email: $email, password: $password, rememberMe: $rememberMe) {
      __typename
    }
  }
`;
